import { type Html, html, rune, View } from 'rune-ts';
import klass from './MainSection.module.scss';
import { font } from '../../../../../shared/typography';

export class MainSection extends View {
  constructor() {
    super({});
  }

  override template(): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const banner_url = is_mobile
      ? '//s3.marpple.co/files/u_4648126/2025/7/original/61509090e6ade8806dc514c37c129cc7638012b91.mp4'
      : '//s3.marpple.co/files/u_4648126/2025/7/original/f0d31462af80de794cf98df02b722ac3f26a164b2.mp4';
    const texts = {
      title: '좋아하는 브랜드와 함께 내 채널 수익을 늘리는 법',
      sub_title: is_mobile
        ? html.preventEscape(`내 SNS 계정으로 수익 만들기!<br />
            마플샵 커머스 크리에이터가<br/> 되어보세요`)
        : html.preventEscape(`내 SNS 계정으로 수익 만들기!<br />
            마플샵 커머스 크리에이터가 되어보세요`),
    };

    return html`
      <section class="${klass.main}">
        <video
          autoplay=""
          loop=""
          muted=""
          playsinline=""
          class="${klass.motion_video}"
          src="${banner_url}"
        ></video>
        <div class="${klass.content}">
          <div class="${font('20_bold', '14_medium')}">${texts.title}</div>
          <div class="${font('48_bold', '28_bold')}">${texts.sub_title}</div>
        </div>
      </section>
    `;
  }
}
